module.exports = __webpack_public_path__ + "img/juxueIcon35.24182a5f.png";